import { RECEIVE_SPECIALISTS } from '../actions';

export default (state = { data: [] }, action) => {
  switch (action.type) {
    case RECEIVE_SPECIALISTS:
      return {
        ...state,
        data: action.data,
      };
    default:
      return state;
  }
};
